{
  "RESET_PASSWORD": {
    "TITLE": "Ponastavi geslo",
    "DESCRIPTION": "Vnesite e-poštni naslov, ki ga uporabljate za prijavo v Chatwoot, da dobite navodila za ponastavitev gesla.",
    "GO_BACK_TO_LOGIN": "Če se želite vrniti na stran za prijavo,",
    "EMAIL": {
      "LABEL": "E-pošta",
      "PLACEHOLDER": "Prosimo, vnesite svoj e-poštni naslov.",
      "ERROR": "Prosimo, vnesite veljaven e-poštni naslov."
    },
    "API": {
      "SUCCESS_MESSAGE": "Povezava za ponastavitev gesla je bila poslana na vaš e-poštni naslov.",
      "ERROR_MESSAGE": "Ni bilo mogoče vzpostaviti povezave s strežnikom. Prosimo poskusite ponovno."
    },
    "SUBMIT": "Pošlji"
  }
}
